
import mobx, { extendObservable, action }from 'mobx';
import axios from 'axios';
import { includes, map } from 'lodash';
import eb from '../utils/EventBus';
import {properties} from '../environments';

const BLOCK_CHAIN_URL = properties.BLOCKCHAIN_URL;

class UploadDataStore {

    constructor() {
        extendObservable(this, {
            loading: true,
            selectedDoc: undefined,
            selectedGrpOption: [],
            selectedShUsersOptions: [],
            selectedShUsers: null,
            selectedRvwUsersOptions: [],
            selectedRvwUsers: null,
            selectedAppUsersOptions: [],
            selectedAppUsers: null,
            shUserIds: [],
            rvwUserIds: [],
            apprUserIds: [],
            username: '',
            orgname: '',
            tokenData: '',
            selectedGrp: null,
            docsize: undefined
        });
    }

    loadShUsers = () => {
      //axios.get('/api/v1/userlist/shusers').then(({ data }) => {
        axios.get('/api/v1/userlist/allusers').then(({ data }) => {
        this.selectedShUsersOptions = data.map(user => ({value: user.userid, label: `${user.email}`}));
      });
    }

    setSelectedShUsers = action((users) => {
          this.selectedShUsers = users;
          this.setShUserId(this.selectedShUsers);

    })

    loadRvwUsers = () => {
      //axios.get('/api/v1/userlist/rvwusers').then(({ data }) => {
      axios.get('/api/v1/userlist/allusers').then(({ data }) => {
        this.selectedRvwUsersOptions = data.map(user => ({value: user.userid, label: `${user.email}`}));
      });
    }

    setSelectedRvwUsers = action((users) => {
         this.selectedRvwUsers = users;
         this.setRvwUserId(this.selectedRvwUsers);
    })

    loadAppUsers = () => {
      //axios.get('/api/v1/userlist/appusers').then(({ data }) => {
      axios.get('/api/v1/userlist/allusers').then(({ data }) => {
        this.selectedAppUsersOptions = data.map(user => ({value: user.userid, label: `${user.email}`}));
      });
    }

    setSelectedAppUsers = action((users) => {
        this.selectedAppUsers = users;
        this.setApprUserId(this.selectedAppUsers);
    })


    getOrgEmail = () => {

       axios.get('/api/v1/uldoc/orgemail')
                    .then(({data}) => {
                      this.username=data.updatedby;
                      this.orgname=data.orgname;
            });
    }


  creDoc = () => {
        console.log(' inside cre doc ');

        if ((this.selectedDoc.comments === null) || (this.selectedDoc.comments ==="") || (this.selectedDoc.comments===undefined))
        {
                  this.selectedDoc.comments='N';
        }

        if ((this.selectedDoc.docdescr === null) || (this.selectedDoc.docdescr ==="") || (this.selectedDoc.docdescr===undefined))
        {
                  this.selectedDoc.docdescr=this.selectedDoc.docname;
        }


            // Create the doc in docmaster
            axios.post('/api/v1/uldoc/create', {
                    doc: this.selectedDoc
                  })
                    .then((response) => {
                      //eb.emit('toast', {
                      //  status: 'success',
                      //  text: 'Document uploaded successfully'
                      //})
                      eb.emit('document-created');
            });


  }

  setDocId = action((val) => {
    console.log(val)
    this.selectedDoc.docid = val;
  })

  setDocName = action((val) => {
    //console.log(val)
    this.selectedDoc.docname = val;
  })


  setDocDescr = action((val) => {
    //console.log(val)
    this.selectedDoc.docdescr = val;
  })

  setDocType = action((val) => {
    //console.log(val)
    this.selectedDoc.doctype = val;
  })

  setDocSize = action((val) => {
    //console.log(val)
    this.selectedDoc.docsize = val;
  })

  setShUserId = action((val) => {
    this.selectedDoc.shUserIds = val;
  })


  setRvwUserId = action((val) => {
    this.selectedDoc.rvwUserIds = val;
  })

  setApprUserId = action((val) => {
    this.selectedDoc.apprUserIds = val;
  })


  setComments = action((val) => {
    //console.log(val)
    this.selectedDoc.comments = val;
  })

  setTag = action((val) => {
    //console.log(val)
    this.selectedDoc.tag = val;
  })

     // Get the BC token

      getBlockChainToken = (username, orgName) => {
          return new Promise((resolve, reject) => {
            axios.post(`${BLOCK_CHAIN_URL}/api/v1/auth_user`, {
                username,
                orgName
            })
                .then(function (response) {
                    //console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                    reject(error);
                });
         });

      }


  loadGrps = () => {
      axios.get('/api/v1/uldoc/grp').then(({ data }) => {
        this.selectedGrpOption = data.map(grp => ({value: grp.grpid, label: `${grp.grpname}`}));
      });
  }

  setSelectedGrp = action((grpoption) => {
      this.selectedGrp = grpoption;
      const sGrp = this.selectedGrp.value;
      const sGName = this.selectedGrp.label;
      this.setGrpId(sGrp);
      this.setGrpName(sGName);
  })

  setGrpId = action((val) => {
    //console.log(val)
    this.selectedDoc.grpid = val;
  })

  setGrpName = action((val) => {
    //console.log(val)
    this.selectedDoc.grpname = val;
  })

  setNewGrp = action((val) => {
    //console.log(val)
    this.selectedDoc.newgrpname = val;
  })

}

const store = new UploadDataStore();
export default store;



// WEBPACK FOOTER //
// ./src/store/uploaddata-store.js